import { observer } from 'mobx-react-lite';
import { useRef, useEffect, useState } from 'react';

const FoldTransition = observer((props) => {
  const {
    children,
    unfolded = false,
    enabled = false,
    className = '',
    transitionDuration = 100,
    beforeGetHeight = () => {},
    beforeTranstion = () => {},
    afterTranstion = () => {}
  } = props;

  const $refContainer = useRef(null);
  const [_interal, _setInteral] = useState(null);
  const [maxHeight, setMaxHeight] = useState('none');

  useEffect(() => {
    beforeGetHeight && beforeGetHeight();
    setTimeout(() => {
      const refContainerNode = $refContainer?.current
      if(refContainerNode && enabled) {
        const scrollHeight = refContainerNode.scrollHeight || 0;
        let ratio = unfolded ? 0 : 1;
        setMaxHeight(unfolded ? '0px' : `${scrollHeight}px`);
        beforeTranstion && beforeTranstion();

        // css
        _interal && clearTimeout(_interal);
        setMaxHeight(`${scrollHeight * (1 - ratio)}px`);
        const interval = setTimeout(() => {
          setMaxHeight('none');
          afterTranstion && afterTranstion();
        }, transitionDuration);
        _setInteral(interval);

        // js
        // _interal && clearInterval(_interal);
        // const interval = setInterval(() => {
        //   ratio += unfolded ? 0.1 : -0.1;
        //   setMaxHeight(`${scrollHeight * ratio}px`);
        //   if(ratio >= 1 || ratio <= 0) {
        //     interval && clearInterval(interval);
        //     if(unfolded) {
        //       setMaxHeight('none');
        //     }
        //     afterTranstion && afterTranstion();
        //   }
        // }, 10)
        // _setInteral(interval);
      }
    }, 20)
  }, [unfolded, enabled])

  useEffect(() => {
    return () => {
      // css
      _interal && clearTimeout(_interal);
      
      // js
      // _interal && clearInterval(_interal);
    }
  }, [])

  return (
    <div 
      className={["overflow-hidden",className]}
      ref={$refContainer}
      style={{
        // css
        height: maxHeight,
        transition: `height ${transitionDuration / 1000}s linear`,
        
        // js
        // maxHeight: maxHeight,
      }}
    >
      {
        children
      }
    </div>
  );
});

export default FoldTransition;